
<div
    [attr.id]="id ? (id + '_overlay') : null"
    class="agpr-popupModal-overlay agpr-clickOutsideExcluded"
    [ngStyle]="{
        'z-index': zIndex
    }"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <div
        #popoverElement
        [id]="id"
        class="agpr-popupModal"
        [ngStyle]="{
            'z-index': zIndex + 1
        }"
        [style.top.px]="positionY"
        [style.left.px]="positionX"
        (clickOutside)="outsideClicked()"

    >
        <div
            [attr.id]="id ? (id + '_modalContent') : null"
            class="agpr-popupModal-content"
        >
            <ng-content></ng-content>
        </div>
    </div>
</div>
